/** CoStar.Api.Suite.Export.ExportFileType */
export var ExportFileType;
(function (ExportFileType) {
    ExportFileType[ExportFileType["None"] = 0] = "None";
    ExportFileType[ExportFileType["CSV"] = 1] = "CSV";
    ExportFileType[ExportFileType["XLS"] = 2] = "XLS";
    ExportFileType[ExportFileType["XML"] = 3] = "XML";
})(ExportFileType || (ExportFileType = {}));
/** @deprecated Please use the values returned by /demographics/lookup/radius/{countryCode}/{cultureCode} instead. */
/** CoStar.Api.Suite.Export.ExportRadius */
export var ExportRadius;
(function (ExportRadius) {
    ExportRadius[ExportRadius["None"] = 0] = "None";
    ExportRadius[ExportRadius["OneMile"] = 1] = "OneMile";
    ExportRadius[ExportRadius["TwoMiles"] = 2] = "TwoMiles";
    ExportRadius[ExportRadius["ThreeMiles"] = 3] = "ThreeMiles";
    ExportRadius[ExportRadius["FiveMiles"] = 4] = "FiveMiles";
    ExportRadius[ExportRadius["TenMiles"] = 5] = "TenMiles";
})(ExportRadius || (ExportRadius = {}));
